/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=ca3b50ae&"
import script from "./headers.vue?vue&type=script&setup=true&lang=ts&"
export * from "./headers.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports